<div class="accordion" [ngClass]="{ 'is-collapsed': !isCollapsed }">
  <div
    class="accordion-header"
    (click)="toggleCollapse()"
    [ngClass]="{ 'is-collapsed': !isCollapsed }"
  >
    <div>
      <h4 class="title">{{ title }}</h4>
      <p class="description" *ngIf="description">
        {{ description }}
      </p>
    </div>

    <div>
      <ng-template [ngIf]="isCollapsed" [ngIfElse]="notCollapsed">
        <i class="icon-caret-down icon-mmb-purple"></i>
      </ng-template>

      <ng-template #notCollapsed>
        <i class="icon-caret-up icon-mmb-purple"></i>
      </ng-template>
    </div>
  </div>
  <div
    #contentRef
    class="accordion-content"
  >
    <ng-content></ng-content>
  </div>
</div>
